import { render, staticRenderFns } from "./public.vue?vue&type=template&id=4b219b16&scoped=true"
import script from "./public.vue?vue&type=script&lang=js"
export * from "./public.vue?vue&type=script&lang=js"
import style0 from "./public.vue?vue&type=style&index=0&id=4b219b16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b219b16",
  null
  
)

export default component.exports